var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sildebar"},[_c('div',{staticClass:"sildebar_logo"},[_c('img',{attrs:{"src":_vm.system.site_logo}})]),_vm._v(" "),_c('el-scrollbar',{staticClass:"sildebar_scroll",class:{isCollapse:_vm.isCollapse}},_vm._l((_vm.sidebar),function(item,index){return _c('sidebar-item',{key:index,attrs:{"item":item}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-154c2f86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","audio":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Sidebar/index.vue
// module id = null
// module chunks = 